import { render } from "./QuestionSlide.vue?vue&type=template&id=1f915cd8&scoped=true"
import script from "./QuestionSlide.vue?vue&type=script&lang=js"
export * from "./QuestionSlide.vue?vue&type=script&lang=js"

import "./QuestionSlide.vue?vue&type=style&index=0&id=1f915cd8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f915cd8"]])

export default __exports__